import React, { Component } from 'react';
import {inject, observer} from 'mobx-react';
import EditOptions from '../../../EditOptions/index';
import {InputField} from '../../../InputForms/index';
import {Icon} from '../../../Buttons/index';
import ConfirmationModal from '../../../ConfirmationModal';
import {IconTypes} from '../../../Buttons';
import styles from './style.css';

@inject('localizationStore')
@observer
class TaskItem extends Component {
    state = {
        disabled: true,
        confirmationModalInfo: null
    }

    onDeleteTask = () => {
        this.setState({confirmationModalInfo: {
                question: this.props.localizationStore.locale.remove_task_question,
                applyAction: () => this.props.task.parentAgent.deleteTaskRequest(this.props.task.id),
                cancelAction: () => this.setState({confirmationModalInfo: null})
            }})
    }

    render() {
        const {editable} = this.props
        return (
            <div className={styles.task}>
                <InputField style={styles.input}
                            required
                            value={this.props.task.description}
                            disabled={true}
                />
                <EditOptions disabled={!editable} onClick={() => this.props.onEditTask(this.props.task)} />
                <Icon disabled={!editable} type={IconTypes.clear} onClick={this.onDeleteTask} />
                {this.state.confirmationModalInfo !== null ?
                    <ConfirmationModal agent={this.props.agent}
                                       question={this.state.confirmationModalInfo.question}
                                       onApply={this.state.confirmationModalInfo.applyAction}
                                       onCancel={this.state.confirmationModalInfo.cancelAction}
                    />
                    : null
                }
            </div>
        );
    }
}

export default TaskItem;


// WEBPACK FOOTER //
// ./src/components/AgentInfo/components/TasksList/TaskItem.js